import { render, staticRenderFns } from "./sdproduct10.vue?vue&type=template&id=713d321c&scoped=true"
import script from "./sdproduct10.vue?vue&type=script&lang=js"
export * from "./sdproduct10.vue?vue&type=script&lang=js"
import style0 from "./sdproduct10.vue?vue&type=style&index=0&id=713d321c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713d321c",
  null
  
)

export default component.exports